import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  Stack,
  InputLabel,
} from "@mui/material";
import {
  TextField,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useFormsFormulaStore from "../../../store/zustandStore/formsFormulaZs";
import SelectFilter from "../../UI/SelectFilter";
import zIndex from "@mui/material/styles/zIndex";
import { TablesModelList } from "../TableWordUtils/TablesModelList";

const NewTableDocModal = ({ isOpen, onClose, dataList, onSelect, year }) => {
  const currentYear = new Date().getFullYear();
  const {
    fetchFormsFormulaZs,
    formsFormulaZs,
    getEvaluateFormFormulaZs,
    evaluateFormFormulaZs,
    getDataForTableChartZs,
    dataForTableChartZs,
    dataForTableChartPostProcessZs,
  } = useFormsFormulaStore();

  const [search, setSearch] = useState("");
  const [newValue, setNewValue] = useState("");
  const [openNewLink, setOpenNewLink] = useState(false);
  const [filteredData, setFilteredData] = useState(TablesModelList);
  const [anchorElForm, setAnchorElForm] = useState(null);

  const [state, setState] = useState({
    formId: "",
    formulaId: "",
    year: year,
    formFormulaType: "SIMPLE",
    formFormula: null,
  });
  const openForm = Boolean(anchorElForm);

  const handleClickForm = (event) => {
    setAnchorElForm(event.currentTarget);
  };

  const handleCloseForm = () => {
    setAnchorElForm(null);
  };

  useEffect(() => {
    setSearch("");
    setNewValue("");
    setOpenNewLink(true);
    setFilteredData(TablesModelList);
    fetchFormsFormulaZs();
    setState({
      formId: "",
      formulaId: "",
      year: year,
      formFormulaType: "SIMPLE",
      formFormula: null,
    });
  }, [isOpen]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    setFilteredData(
      TablesModelList.filter((item) =>
        item?.modelLabel?.toLowerCase().includes(value?.toLowerCase())
      )
    );
  };
  const onChangeNewValue = (e) => {
    const value = e.target.value;
    setNewValue(value);
  };

  const handleSelectModel = (item) => {
    // onSelect(item);
    const newContentApi = {
      modelId: item?.modelId,
      modelLabel: item?.modelLabel,
      formulaId: state.formulaId,
      year: state.year,
      formFormulaType: state.formFormulaType,
      data: item?.data,
      postProcessing: state?.postProcessing,
      apiEndpoint: state?.apiEndpoint,
    };

    onSelect(newContentApi);
    onClose();
  };

  const handleAddNew = () => {
    if (newValue.trim()) {
      const newData = { label: newValue.trim(), url: newValue.trim() };
      onSelect(newData);
      onClose();
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      sx={{
        zIndex: 1000,
        "& .MuiDialogContent-root": {
          padding: 2,
        },
        "& .MuiDialogActions-root": {
          padding: 2,
        },
        "& .MuiPaper-root.MuiDialog-paper": {
          minWidth: "600px",
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Zgjidh te dhenat dhe Modelin
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Stack spacing={2} sx={{ mr: "10px" }}>
          <InputLabel required>Thirrja e të dhënave</InputLabel>
          <SelectFilter
            textfield
            maxWidth={"100%"}
            // disabledfilter={!state.reportingUnitId}
            name="formulaId"
            id="formulaId"
            label="Thirrja e të dhënave"
            placeholder="Kërko Thirrje te dhenash"
            noOptionsText="Nuk ka Thirrje te dhenash"
            value={state.formulaId}
            onClick={handleClickForm}
            source={formsFormulaZs}
            open={openForm}
            anchorEl={anchorElForm}
            onClickAway={handleCloseForm}
            onClose={(event, reason) => {
              if (reason === "escape") {
                handleCloseForm();
              }
            }}
            onChange={(event, newValue, reason) => {
              if (
                event.type === "keydown" &&
                event.key === "Backspace" &&
                reason === "removeOption"
              ) {
                return;
              }
              setState({
                ...state,
                formId: newValue?.id ? newValue?.id : "",
                formulaId: newValue?.id ? newValue?.id : "",
                formFormulaType: newValue?.type ?? "SIMPLE",
                formFormula: newValue ?? null,
                name: newValue?.name ?? "",
                postProcessing: newValue?.postProcessing ?? null,
                apiEndpoint:
                  newValue?.payload?.apiFormFormula?.apiEndpoint ?? "",
              });
              // getAllDataFormIndikator();
              handleCloseForm();
            }}
            zIndexPopper={10000}
            sx={{ zIndex: "2000" }}
            // onchangesearch={searchItemsForm}
            // inputRef={searchStateForm}
          ></SelectFilter>
        </Stack>
      </DialogContent>
      {state?.formulaId && (
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Kerko dhe zgjidh Modelin..."
            value={search}
            onChange={handleSearch}
            margin="dense"
            sx={{
              "& .MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-root fieldset":
                {
                  border: "2px solid #3B376C",
                },
            }}
          />
        </DialogContent>
      )}
      {state?.formulaId && (
        <DialogContent>
          <List sx={{ height: "250px" }}>
            {filteredData.map((item) => (
              <ListItem key={item.modelId} disablePadding>
                <ListItemButton onClick={() => handleSelectModel(item)}>
                  <ListItemText primary={item.modelLabel} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
      )}
      {/* <Box
        sx={{
          padding: 1,
          borderTop: "1px solid black",
          display: "flex",
          justifyContent: "end",
          cursor: "pointer",
        }}
        onClick={() => setOpenNewLink(!openNewLink)}
      >
        {openNewLink ? "🔽 Shto Model te Ri " : "🔼 Mbyll"}
      </Box> */}
      {!openNewLink && (
        <DialogActions sx={{ display: "flex", flexDirection: "column" }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Link i ri"
            value={newValue}
            onChange={onChangeNewValue}
            margin="dense"
            sx={{
              "& .MuiInputBase-root.MuiOutlinedInput-root.MuiOutlinedInput-root fieldset":
                {
                  border: "1px solid #3B376C",
                },
            }}
          />
          <Button
            onClick={handleAddNew}
            variant="contained"
            color="primary"
            fullWidth
          >
            Shto
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default NewTableDocModal;
